<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div ref="totalRef" class="subpage">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" title="姓名吉凶" :is-sub-page="true">
      <!--
      <template v-slot:rightBtn>
        <span class="btn btn-share" @click="shareClick"></span>
      </template>
      -->
    </Header>

    <div ref="contentRef" class="form-content">
      <div style="padding-bottom: 78%; height: 0">
        <img src="@/assets/images/backgrounds/bg-xmjx.png" alt="pic" class="bg-img"/>
      </div>
      <Form ref="formRef"
            :models="model"
            :formFields="fields"
            :items="items"
            btnMsg="测算"
            @submitClick="goResult"></Form>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Form from '../../components/Form'

export default {
  name: 'Name',
  components: {
    Header,
    Form
  },
  data () {
    return {
      backgroundUrl: '',
      computedHeight: 0,
      model: {
        firstNameValue: '',
        lastNameValue: '',
        sexValue: '',
        userValue: ''
      },
      items: ['input', 'input', 'radio', 'button', 'userradio'],
      fields: [
        {
          type: 'input',
          modelKey: 'firstNameValue',
          label: '姓',
          props: {
            placeholder: '请输入您的姓氏',
            autofocus: true,
            autoExpand: true,
            maxlength: 300
          },
          rules: {
            required: true,
            pattern: /[\u4e00-\u9fa5]+/
          },
          messages: {
            required: '请输入姓氏',
            pattern: '请输入中文'
          }
        },
        {
          type: 'input',
          modelKey: 'lastNameValue',
          label: '名',
          props: {
            placeholder: '请输入您的名字'
          },
          rules: {
            required: true,
            pattern: /[\u4e00-\u9fa5]+/
          },
          messages: {
            required: '请输入名字',
            pattern: '请输入中文'
          }
        },
        {
          type: 'radio-group',
          modelKey: 'sexValue',
          label: '性别',
          props: {
            options: ['男', '女'],
            horizontal: true,
            hollowStyle: true
          }
        },
        {
          type: null
        },
        {
          type: 'radio-group',
          modelKey: 'userValue',
          props: {
            options: ['我已阅读并同意《用户隐私协议》'],
            horizontal: true,
            hollowStyle: true
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  mounted () {
    document.title = '姓名吉凶'
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }
  },
  methods: {
    getResultPath () {
      return 'result?firstName=' + this.model.firstNameValue + '?lastName=' + this.model.lastNameValue + '?sex=' + this.model.sexValue === '男' ? 0 : 1
    },

    goResult () {
      console.log('go result')

      this.$router.push({
        path: 'luckResult',
        query: {
          firstName: this.model.firstNameValue,
          lastName: this.model.lastNameValue,
          sex: this.model.sexValue ? (this.model.sexValue === '男' ? 0 : 1) : '',
          platform: this.$route.query.platform
        }
      })
    },
    shareClick () {
      console.log('姓名吉凶 share')
      this.$dfzhJsBridge.share({
        url: process.env.VUE_APP_SHARE_URL + '/nameLuck?protocol=true',
        title: '东方智汇姓名吉凶',
        description: ' '
      })
    }
  }
}
</script>

<style lang="stylus" scoped src="@/style/form.styl"></style>

<style lang="stylus" scoped>
.subpage
  background url("~@/assets/images/backgrounds/bg.png") no-repeat center
  background-size 100% 100%
</style>

<style lang="stylus">
body
  background-color #EFE9E0
</style>
